export enum AppTabKey {
  BILL_TAB_STATE_KEY = 'billTabSateKey',
  MENU_STATE_KEY = 'menuState',
}
